<div class="scope-report">
  <div class="scope-report-section">
    <div class="row">
      <div class="col-md-6">
        <div class="heading">
          <span [class.text-danger]="mp4StudyFiles.length === 0"
            >Scope Video
          </span>

          <ng-container *ngIf="mp4StudyFiles.length === 0; else regularCount">
            <span class="badge bg-danger">0 of 1</span>
          </ng-container>

          <ng-template #regularCount>
            <span class="badge bg-success">{{ mp4StudyFiles.length }}</span>
          </ng-template>
        </div>

        <div class="row">
          <div *ngFor="let studyFile of mp4StudyFiles" class="col-md-3">
            <div class="xray-wrapper">
              <div
                class="outlay-outer flex align-items-center justify-content-center"
              >
                <div
                  class="outlay-inner flex align-items-center justify-content-center"
                >
                  <i class="fa fa-file-video show"></i>
                  <i
                    class="fa fa-play hidden"
                    (click)="playVideo(studyFile)"
                  ></i>
                </div>
              </div>

              <div class="text-success">Existing</div>
              <div class="small-text">
                Submitted by {{ studyFile.createdByUser.name }} <br />
                {{ studyFile.createdDate | date : "medium" }}
              </div>
            </div>
          </div>
          <div
            class="col-md-3"
            *ngIf="currentMp4Count !== mp4StudyFiles.length; else uploadMp4"
          >
            <div class="xray-wrapper">
              <div
                class="outlay-outer flex align-items-center justify-content-center"
              >
                <div class="flex align-items-center justify-content-center">

                </div>
              </div>
            </div>
          </div>

          <ng-template #uploadMp4>
            <div class="col-md-3">
              <app-upload-file
                [disabled]="currentMp4Count !== mp4StudyFiles.length"
                (uploadFiles)="selectMp4Files($event)"
              ></app-upload-file>
            </div>
          </ng-template>
        </div>
      </div>

      <div class="col-md-6">
        <div class="heading">
          <span [class.text-danger]="pdfStudyFiles.length === 0"
            >X-Ray Report
          </span>

          <ng-container *ngIf="pdfStudyFiles.length === 0; else regularCount">
            <span class="badge bg-danger">0 of 1</span>
          </ng-container>

          <ng-template #regularCount>
            <span class="badge bg-success">{{ pdfStudyFiles.length }}</span>
          </ng-template>
        </div>

        <div class="row">
          <div *ngFor="let studyFile of pdfStudyFiles" class="col-md-3">
            <div class="xray-wrapper">
              <div
                class="outlay-outer flex align-items-center justify-content-center"
              >
                <div
                  class="outlay-inner flex align-items-center justify-content-center"
                >
                  <div class="pdf-link">
                    <i class="far fa-file-pdf" (click)="openPdf(studyFile)"></i>
                  </div>
                </div>
              </div>
              <div class="text-success">Existing</div>
              <div class="small-text">
                Submitted by {{ studyFile.createdByUser.name }} <br />
                {{ studyFile.createdDate | date : "medium" }}
              </div>
            </div>
          </div>
          <div
            class="col-md-3"
            *ngIf="currentPdfCount !== pdfStudyFiles.length; else uploadPDF"
          >
            <div class="xray-wrapper">
              <div
                class="outlay-outer flex align-items-center justify-content-center"
              >
                <div class="flex align-items-center justify-content-center">

                </div>
              </div>
            </div>
          </div>

          <ng-template #uploadPDF>
            <div class="col-md-3">
              <app-upload-file
                [disabled]="currentPdfCount !== pdfStudyFiles.length"
                (uploadFiles)="selectPdfFiles($event)"
              ></app-upload-file>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
